import AntdAvatar from 'components/Avatar'
import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import DeleteIcon from 'components/icons/DeleteIcon'
import ConfirmReleaseOffer from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/ConfirmReleaseOffer/index'
import PreviewOfferLetter from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/PreviewOfferLetter/index'
import {
  CollageDetailsFlex,
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  CommonFlex,
  ContentDiv,
  FooterFlex,
  IconWrap,
  SubTitleDiv,
  Summary,
  SummaryDiv,
  TitleDiv,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/ReviweOfferDrawer/style'
import moment from 'moment'
import React, { Fragment, useState } from 'react'

const ReviewOffer = ({
  reviewOffer,
  setReviewOffer,
  setReleaseOffer,
  setIsConfirm,
  onSubmitFormData,
  previewData,
  confirmOffer,
  setConfirmOffer,
  isLoading,
  selectedCandidate,
  setSelectedCandidate,
  setSelectedCandidateId,
  singleRoleData,
}) => {
  const [offerLetter, setOfferLetter] = useState(false)

  const handleConfirm = () => {
    onSubmitFormData(previewData)
  }

  const onDeleteCandidate = value => {
    let updatedList = selectedCandidate?.filter(data => data?.id !== value)
    setSelectedCandidate(updatedList)
    setSelectedCandidateId(updatedList?.map(({ id }) => id))
  }

  const summary = [
    {
      title: 'Roles',
      details: singleRoleData?.tittle,
    },
    {
      title: 'Designation',
      details: previewData?.designation,
    },
    {
      title: 'Job Location',
      details: previewData?.jobLocation,
    },
    {
      title: 'Compensation',
      details: `₹ ${previewData?.salary}`,
    },
    {
      title: 'Bonus',
      details: `${previewData?.bouns ? 'yes' : 'NA'}`,
    },
    {
      title: 'Offer Expiry Date',
      details: moment(previewData?.offerExpireDate).format('DD/MM/YYYY'),
    },
  ]

  const content = () => {
    return (
      <>
        {!confirmOffer && (
          <div>
            {' '}
            <SummaryDiv>
              <Summary>Summary</Summary>
              {summary.map((item, index) => (
                <CommonFlex key={index + item?.title} spaceBetween>
                  <SubTitleDiv>{item?.title}</SubTitleDiv>
                  <ContentDiv>{item?.details}</ContentDiv>
                </CommonFlex>
              ))}
            </SummaryDiv>
            {selectedCandidate?.length > 1 && (
              <Fragment>
                <TitleDiv>
                  For the following Candidates ({selectedCandidate?.length})
                </TitleDiv>
                {selectedCandidate?.map((data, key) => (
                  <CollageDetailsFlex
                    key={key + 'candidates'}
                    spaceBetween
                    centerVertically
                  >
                    <Flex alignCenter>
                      <AntdAvatar
                        size={36}
                        src={data?.student?.profileUrl}
                        IconName={data?.student?.first_name
                          ?.charAt(0)
                          ?.toUpperCase()}
                      />

                      <CollageNameFlex>
                        <CollegeNameDiv>
                          {data?.student?.firstName} {data?.student?.lastName}
                        </CollegeNameDiv>
                        <CollegeCity>{data?.student?.prefixId}</CollegeCity>
                      </CollageNameFlex>
                    </Flex>
                    <IconWrap onClick={() => onDeleteCandidate(data?.id)}>
                      <DeleteIcon />
                    </IconWrap>
                  </CollageDetailsFlex>
                ))}
              </Fragment>
            )}
          </div>
        )}
        {confirmOffer && (
          <ConfirmReleaseOffer
            setReviewOffer={setReviewOffer}
            setConfirmOffer={setConfirmOffer}
            offerLetter={offerLetter}
            setOfferLetter={setOfferLetter}
            selectedCandidate={selectedCandidate}
          />
        )}
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          text="Back to edit"
          height="38px"
          onClick={() => {
            setReleaseOffer(true)
            setReviewOffer(false)
            setIsConfirm(false)
          }}
        />

        <Button.Primary
          text="Confirm"
          height="38px"
          onClick={handleConfirm}
          loading={isLoading}
        />
      </FooterFlex>
    )
  }
  return (
    <>
      <Drawer
        width="43%"
        title={confirmOffer ? 'Schedule' : 'Review - Intent to Offer'}
        placement="right"
        visible={reviewOffer}
        content={content()}
        footer={!confirmOffer && footer()}
        onClose={() => {
          setReviewOffer(false)
        }}
        closable
      />
      <PreviewOfferLetter
        offerLetter={offerLetter}
        setOfferLetter={setOfferLetter}
      />
    </>
  )
}

export default ReviewOffer
